/*
 * @Date: 2023-07-24 17:47:50
 * @LastEditors: wuyanfeiying
 * @desc: dom相关操作 工具类
 */

// 检查设备是否是桌面端或者移动端
export const matchMedia = function () {
  // 这里css媒体查询设置的像素，是在 App.vue 中设置的
  let isDesktop = window.matchMedia('(min-width: 769px)').matches
  let isMobile = window.matchMedia('(max-width: 768px)').matches

  if (isDesktop) {
    // console.log('当前是桌面端')
    return 'isDesktop'
  } else if (isMobile) {
    // console.log('当前是移动端')
    return 'isMobile'
  } else {
    // console.log('无法确定设备类型')
    return ''
  }
}

// 模拟a标签跳转页面
export const clickAndRemoveLink = function (url) {
  console.log(' ~ file: DomTool.js:27 ~ clickAndRemoveLink ~ url:', url)
  const link = document.createElement('a')
  link.href = url
  link.style.display = 'none'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}



// WEBPACK FOOTER //
// ./src/utils/DomTool.js